import { render, staticRenderFns } from "./FeedbackToolbar.vue?vue&type=template&id=ac50f9a0"
import script from "./FeedbackToolbar.vue?vue&type=script&lang=ts"
export * from "./FeedbackToolbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports